import { render } from "./EposFullPageContainer.vue?vue&type=template&id=10059646"
import script from "./EposFullPageContainer.vue?vue&type=script&lang=js"
export * from "./EposFullPageContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__